var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.48 92.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9c3014;}.cls-2{fill:#d83f16;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.61,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.61,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.22,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.22,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.83,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.83,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.44,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.44,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.04,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.04,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.65,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.65,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.26,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.26,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.87,
    y: 6.61,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.26,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.65,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.04,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.44,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.83,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.61,
    y: 13.22,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.04,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.44,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.83,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.61,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.65,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.04,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.44,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.83,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.61,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.04,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.44,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.83,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.61,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.44,
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.83,
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.61,
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.22,
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.65,
    y: 19.83,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.04,
    y: 26.44,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 39.65,
    y: 33.04,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 46.26,
    y: 39.65,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.87,
    y: 46.26,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 52.87,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 59.48,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 66.09,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 72.7,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 79.31,
    width: 6.61,
    height: 6.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 85.92,
    width: 6.61,
    height: 6.61
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag3);
export default __webpack_public_path__ + "static/media/flag-3.8ac74696c26f98ee8f70e4164fa4b4d0.svg";
export { ForwardRef as ReactComponent };